import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

import type {FontAwesomeIconProps} from '@fortawesome/react-fontawesome';

export function Icon(props: FontAwesomeIconProps): React.JSX.Element {
  return (
    <FontAwesomeIcon
      aria-hidden="true"
      {...props}
      // remove _icon once styled-components is removed
      className={clsx(props.className, '_icon')}
    />
  );
}
